import { createSlice } from '@reduxjs/toolkit';
import { saveToCache, loadFromCache, CACHE_KEYS } from '../data/cache';

const TAG = '[userSlice]';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    authUserId: null,
    session: null,
    profile: null,
    profileLoading: 'idle', // 'idle' | 'loading' | 'saving' | 'syncing' | 'error'
    profileUpdatingCount: 0, // Counter for tracking concurrent profile updates
    profileUpdatingError: null, // Error message when update fails
    uploadsInProgress: [], // Array of upload objects { id, file, progress, startTime, status }
  },
  reducers: {
    setAuthUser: (state, action) => {
      state.authUserId = action.payload;
      saveToCache(CACHE_KEYS.AUTH_USER_ID, action.payload);
    },
    setSession: (state, action) => {
      state.session = action.payload;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
      if (action.payload?.id) {
        saveToCache(CACHE_KEYS.PROFILE(action.payload.id), action.payload);
      }
    },
    setProfileLoading: (state, action) => {
      state.profileLoading = action.payload;
    },
    loadProfileFromCache: (state, action) => {
      const cached = loadFromCache(CACHE_KEYS.PROFILE(action.payload));
      if (cached?.id === action.payload) state.profile = cached;
      state.profileLoading = true;
    },
    incrementProfileUpdating: (state) => {
      state.profileUpdatingCount += 1;
      state.profileUpdatingError = null; // Clear error on new update
    },
    decrementProfileUpdating: (state) => {
      state.profileUpdatingCount = Math.max(0, state.profileUpdatingCount - 1);
    },
    setProfileUpdatingError: (state, action) => {
      state.profileUpdatingError = action.payload;
    },
    addUploadInProgress: (state, action) => {
      state.uploadsInProgress.push(action.payload);
    },
    removeUploadInProgress: (state, action) => {
      state.uploadsInProgress = state.uploadsInProgress.filter(u => u.id !== action.payload);
    },
  },
});

export const {
  setAuthUser,
  setSession,
  setProfile,
  setProfileLoading,
  loadProfileFromCache,
  incrementProfileUpdating,
  decrementProfileUpdating,
  setProfileUpdatingError,
  addUploadInProgress,
  removeUploadInProgress,
} = userSlice.actions;
export default userSlice.reducer;
